import React from 'react';
import { Check, X } from 'react-feather';

const QuestionRow = ({ question, index }) => {
  const correctnessIconFragment = result => {
    if (result === 'correct') {
      return (
        <Check
          strokeWidth="6"
          size="18"
          className="c-success pr-4 pt-6"
          aria-label={t('progress.report_card.elearning.correct')}
        />
      );
    }
    if (result === 'incorrect') {
      return (
        <X
          strokeWidth="6"
          size="18"
          className="c-danger-red pr-4 pt-6"
          aria-label={t('progress.report_card.elearning.incorrect')}
        />
      );
    }
    return false;
  };
  const questionNumber = index + 1;
  return (
    <tr className={`ReportCard-row--${question.result}`}>
      <td>
        <span
          aria-label={t('progress.report_card.elearning.question_number', {
            questionNumber,
          })}
        >
          {correctnessIconFragment(question.result)}
          {questionNumber}.
        </span>
      </td>
      <td>{question.question_text}</td>
      <td className="ReportCard-givenAnswer">{question.given_answer}</td>
      <td>{question.correct_answers.join(', ')}</td>
    </tr>
  );
};

const QuestionAnalytics = ({ questionData, id }) => {
  return (
    <td colSpan={5} id={id}>
      <table className="DataTable Table ReportCard-QuestionAnalytics w-full">
        <thead>
          <tr>
            <th />
            <th className="w-50p">
              {t('progress.report_card.elearning.question')}
            </th>
            <th>{t('progress.report_card.elearning.given_answer')}</th>
            <th>{t('progress.report_card.elearning.correct_answer')}</th>
          </tr>
        </thead>
        <tbody>
          {questionData?.map((question, index) => (
            <QuestionRow key={question.id} question={question} index={index} />
          ))}
        </tbody>
      </table>
    </td>
  );
};

export default QuestionAnalytics;
